import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Resource } from '@app/shared/enums';
import { GrantSelectors, ResourceAccessSelectors } from '@app/store';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export const myFparGuard: CanActivateFn = () => {
  const store$ = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store$.select(GrantSelectors.selectSelectedGrant),
    store$.select(ResourceAccessSelectors.selectResourceAccess),
  ]).pipe(
    filter(([selectedGrant, permissions]) => !!selectedGrant && !!permissions),
    map(([selectedGrant, permissions]) => {
      if (selectedGrant.subrecipientId) {
        router.navigate(['/clinic-locator']);
        return false;
      } else if (!permissions[Resource.ViewMyFparPage]) {
        router.navigate(['/dashboard']);
        return false;
      } else {
        return true;
      }
    }),
  );
};
